import api from '@/utils/api';

export default new class Ajax {
    getReusablePhotos(params) {
        return api.get('/api/shift-report/reusable-photos', {params, ignoreModal: true}).then(({data}) => data);
    }
    getExplanationSuggestions(params) {
        return api.get('/api/shift-report/explanation-suggestions', {params, ignoreModal: true}).then(({data}) => data);
    }
    getExplanationStatistics() {
        return api.get('/api/shift-report/explanation-statistics', {ignoreModal: true}).then(({data}) => data);
    }
    getSubmissionSettings() {
        return api.get('/api/shift-report/submission-settings', {ignoreModal: true}).then(({data}) => data);
    }
    getObjects() {
        return api.get(`/api/shift-report/building-processes`).then(({data}) => data);
    }

    getTargets(building_process_id) {
        return api.get(`/api/shift-report/targets`, {
            params: {
                building_process_id
            }
        }).then(({data}) => data);
    }

    getFuelLimits(building_process_id) {
        return api.get(`/api/shift-report/fuel-limits`, {
            params: {
                building_process_id
            }
        }).then(({data}) => data);
    }

    getMaterials(work_id) {
        return api.get(`/api/shift-report/materials/work/${work_id}`).then(({data}) => data);
    }

    createCache(payload) {
        return api.post(`/api/shift-report/cache`, payload).then(({data}) => data);
    }

    updateCache(id, payload) {
        return api.put(`/api/shift-report/cache/${id}`, payload).then(({data}) => data);
    }

    uploadTempPhoto(file) {
        const formData = new FormData();
        formData.append('photo', file);
        return api.post(`/api/shift-report/temp-photo`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            ignoreModal: true
        }).then(({ data }) => data);
    }

    deleteTempPhotos(ids) {
        return api.delete(`/api/shift-report/temp-photo`, {
            data: { ids },
            ignoreModal: true
        }).then(({ data }) => data);
    }

    attachTempPhotos({ shiftId, tempIds }) {
        return api.post(`/api/shift-report/photos/attach-temp`, {
            shiftId,
            tempIds
        }, {
            ignoreModal: true
        }).then(({ data }) => data);
    }

    commitTempPhotos({ shiftId, tempIds }) {
        return api.post(`/api/shift-report/photos/commit-temp`, {
            shiftId,
            tempIds
        }, {
            ignoreModal: true
        }).then(({ data }) => data);
    }

    finalizePhotos(shiftId) {
        return api.post(`/api/shift-report/photos/finalize`, { shiftId }).then(({data}) => data);
    }

    getPhotosStatus(shiftId) {
        return api.get(`/api/shift-report/photos/status`, { params: { shiftId } }).then(({data}) => data);
    }

    sendReport(payload) {
        return api.post(`/api/shift-report/report`, payload, {ignoreModal: true}).then(({data}) => data);
    }

    finishReportNotification(shiftId) {
        return api.post(`/api/report-finish`, {
            shift_id: shiftId
        }, {
            params: {
                withoutPhoto: true
            }
        }).then(({data}) => data);
    }   

    sendPhotos(shiftId) {
        return api.post(`/api/shift-report/send-photos`, {
            shiftId
        }).then(({data}) => data);
    }

    sendReasonForDelay(shiftId) {
        return api.post(`/api/shift-report/send-reason-for-delay`, {
            shiftId
        }).then(({data}) => data);
    }   

    sendTriggerToSendPhotoFromChat(payload) {
        return api.post(`/api/shift-report/send-trigger-to-send-photo-from-chat`, payload).then(({data}) => data);
    }

    resendProcessedPhotos(shiftId) {
        return api.post(`/api/shift-report/photos/resend-processed`, { shiftId }).then(({data}) => data);
    }
}
